import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo })
  }

  handleReload = () => {
    window.location.href = '/'
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          padding: 24,
          textAlign: 'center',
          fontFamily: 'sans-serif'
        }}>
          <h2>Что-то пошло не так</h2>
          <p>Произошла непредвиденная ошибка. Попробуйте перезагрузить страницу.</p>
          <button
            onClick={this.handleReload}
            style={{
              padding: '10px 24px',
              fontSize: 14,
              cursor: 'pointer',
              backgroundColor: '#f57c00',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              marginTop: 8
            }}
          >
            На главную
          </button>
          <details style={{ whiteSpace: 'pre-wrap', marginTop: 24, maxWidth: 800, textAlign: 'left', color: '#888' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary
